import FilterCollapse from "@/features/sub-families/components/filter-collapse.tsx";
import { useTranslations } from "@/features/translations/components/translations.tsx";
import { useAppSelector } from "@/redux/store.ts";
import { LABEL_DELIMITER } from "@/resources/constants.ts";
import SubFamilies from "./internal/sub-families.tsx";

const PRODUCT_PROPERTY = "sub_families";

export default function SubFamiliesFilter() {
    const t = useTranslations();

    const installationOptions = useAppSelector((state) => state.installations.options);
    const installationId = useAppSelector((state) => state.installations.activeId);
    const subFamily = useAppSelector((state) => state.subFamily.name);

    const installation = installationId ? installationOptions[installationId] : "";

    const label = [installation, subFamily].filter(Boolean).join(LABEL_DELIMITER);

    return (
        <FilterCollapse
            productProperty={PRODUCT_PROPERTY}
            title={<span>{t("sub_family")}</span>}
            details={label}
            defaultOpenWhenNoProperty
        >
            <SubFamilies />
        </FilterCollapse>
    );
}
